var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSaveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7825 3.9675L14.0325 0.217497C13.9624 0.147986 13.8793 0.0929923 13.7879 0.0556688C13.6966 0.0183454 13.5987 -0.000573393 13.5 -2.72307e-06H1.5C1.10218 -2.72307e-06 0.720644 0.158032 0.43934 0.439337C0.158035 0.720642 0 1.10217 0 1.5V16.5C0 16.8978 0.158035 17.2794 0.43934 17.5607C0.720644 17.842 1.10218 18 1.5 18H16.5C16.8978 18 17.2794 17.842 17.5607 17.5607C17.842 17.2794 18 16.8978 18 16.5V4.5C18.0006 4.40129 17.9817 4.30345 17.9443 4.21207C17.907 4.12069 17.852 4.03758 17.7825 3.9675ZM6 1.5H12V4.5H6V1.5ZM12 16.5H6V10.5H12V16.5ZM13.5 16.5V10.5C13.5 10.1022 13.342 9.72064 13.0607 9.43934C12.7794 9.15803 12.3978 9 12 9H6C5.60218 9 5.22064 9.15803 4.93934 9.43934C4.65804 9.72064 4.5 10.1022 4.5 10.5V16.5H1.5V1.5H4.5V4.5C4.5 4.89782 4.65804 5.27935 4.93934 5.56066C5.22064 5.84196 5.60218 6 6 6H12C12.3978 6 12.7794 5.84196 13.0607 5.56066C13.342 5.27935 13.5 4.89782 13.5 4.5V1.8075L16.5 4.8075V16.5H13.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveIcon);
export default __webpack_public_path__ + "static/media/save-icon.afc3395d2aa2a10cba94950ce9d1e101.svg";
export { ForwardRef as ReactComponent };